import axios from "axios"
import store from "@/student/store"

function resolveBaseUrl() {
    if (typeof window !== "undefined" && window.EAFFIDAVIT_API) {
        return window.EAFFIDAVIT_API
    }
    return "https://eaffidavit.smartedged.com"
}

const eaffidavitClient = axios.create({
    baseURL: resolveBaseUrl(),
    timeout: 1000 * 60 * 5,
})

// HMAC portal signing happens server-side (portal proxy), NOT here.
// The frontend forwards:
//  - Authorization: Bearer <portal JWT>  — so the proxy can authorise the session
//  - X-Student-Id: <matric>              — the student's stable id (matric number),
//                                          which the E-Affidavit service requires and
//                                          includes in the HMAC canonical message.
eaffidavitClient.interceptors.request.use(async config => {
    config.headers = config.headers || {}

    try {
        const LoginUtil = (await import("@/login/LoginUtil")).default
        const token = await LoginUtil.getAccessTokenAsync()
        if (token) config.headers.Authorization = `Bearer ${token}`
    } catch (_e) { /* no-op */ }

    const user = store?.getters?.getUser
    const studentId = user?.userId || user?.matric || user?.matricNumber
    if (studentId) config.headers["X-Student-Id"] = String(studentId)

    return config
})

export default eaffidavitClient
